import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import {
  NotificationContent,
  NotificationContentKey,
} from '../models/NotificationContent'
import { NOTIFICATION_CONTENTS_URL } from '../utils/urls'

const fetchNotificationContents = (keys: NotificationContentKey[]) =>
  SBAPI.FetchPaginated<NotificationContent[]>(NOTIFICATION_CONTENTS_URL, {
    ...initialQuery,
    pagination: { current: 1, pageSize: 1000 },
    filters: { keys },
  })

const fetchNotificationContentById = (id: number) =>
  SBAPI.Fetch<NotificationContent>(`${NOTIFICATION_CONTENTS_URL}/${id}`)

const saveNotificationContent = (content: NotificationContent) =>
  SBAPI.Post(NOTIFICATION_CONTENTS_URL, content)

export {
  fetchNotificationContentById,
  fetchNotificationContents,
  saveNotificationContent,
}
